import styled from 'styled-components';

import { StyledFlexContainer } from 'src/components/core/layout/FlexContainer';

export const OrderBookContainer = styled.div<{ isTradeExpand?: boolean }>`
    ${({ theme: { colors, breakpoints }, isTradeExpand }) => `
        display: flex;
        flex-direction: column;
        height: ${isTradeExpand ? `100vh` : `100%`};
        width: 100%;
        border-right: 1px solid ${colors.border.light};
        border-bottom: 1px solid ${colors.border.light};
        @media (max-width: ${breakpoints.md}) {
            min-width: 100%;
            min-height: 321px;
            width: 100%;
            height: 50vh;
            border-right: 0;
            padding-top: 16px;
        }
        @media (max-width: ${breakpoints.xl}) {
            height: ${isTradeExpand ? `100vh` : `calc(100% - 40px)`};
        }
    `};
`;

export const ListHeader = styled(StyledFlexContainer)<{ isTradeExpand?: boolean }>`
    flex-direction: column;
    align-items: flex-start;
    padding: 4px 12px;
    width: 100%;
    & .sorting-icons {
        padding: 2px 0;
        & span:not(:last-of-type) {
            margin-right: 2px;
        }
    }
    & .selectBox {
        & > div:first-of-type {
            height: 28px !important;
            min-width: 80px !important;
            float: right;
        }
        & > div:last-of-type {
            & > .select-item {
                height: 28px !important;
            }
        }
    }
    ${({ theme: { breakpoints, typography }, isTradeExpand }) => `
        & >div:nth-of-type(1) {
            & > svg {
                display: none;
                ${
                    !isTradeExpand
                        ? `@media (min-width: ${breakpoints.xxl}) {
                                display: block;
                            }`
                        : ``
                }
            }
            & > span {
                display: none;
                ${
                    !isTradeExpand
                        ? `@media (min-width: ${breakpoints.xxl}) {
                                display: block;
                                font-size: ${typography.size.desktop.paragraph.p2};
                                line-height: ${`calc(${typography.lineHeight[3]} - 0.5px)`};
                                font-weight: ${typography.weight.medium};
                                margin-bottom: 8px;
                            }`
                        : ``
                }
            }
        }
        @media (max-width: ${breakpoints.md}) {
            padding: 0 16px;
            & .selectBox {
                & > div:first-of-type {
                    height: 28px !important;
                    float: none;
                }
                & > div:last-of-type {
                    left: 0px !important;
                }
            }
        }
    `};
`;

export const ListTitle = styled(StyledFlexContainer)<{ isTradeExpand?: boolean }>`
    justify-content: space-between;
    padding: 9px 16px;
    width: 100%;
    ${({ theme: { typography, colors, breakpoints }, isTradeExpand }) => `
        & > span {
            color: ${colors.text.tertiary};
            font-size: ${typography.size.desktop.paragraph.p3};
            line-height: calc(${typography.lineHeight[2]} - 1px);
            letter-spacing: -0.02em;
            &:nth-of-type(1) {
                width: ${!isTradeExpand ? '30%' : '33.33%'};
            }
            &:nth-of-type(2),
            &:nth-of-type(3) {
                width: ${!isTradeExpand ? '35%' : '33.33%'};
                text-align: end;
            }
            &:nth-of-type(2) {
                text-align: ${!isTradeExpand ? 'end' : 'center'};
                @media (max-width: ${breakpoints.md}) {
                    text-align: center;
                }
            }
        }
        @media (max-width: ${breakpoints.md}) {
            padding: 8px 16px;
            & > span {
                width: 33.33% !important;
            }
        }
    `};
`;
export const TokenPriceContainer = styled(StyledFlexContainer)`
    justify-content: space-between;
    align-items: flex-start;
    padding: 15px 16px;
    width: 100%;
    ${({ theme: { colors } }) => `
            border: 1px solid ${colors.border.light};
    `};
`;
export const TokenPriceItem = styled(StyledFlexContainer)`
    ${({ theme: { typography, colors } }) => `
        width: 100%;
        gap: 12px;
        & > span {
            &:nth-of-type(1) {
                display: flex;
                align-items: center;
                font-size: ${typography.size.desktop.heading.h7};
                line-height: calc(${typography.lineHeight[5]} - 0.5px);
                font-weight: ${typography.weight.medium};
                letter-spacing: -0.02em;
                &.down > svg {
                    transform: rotate(180deg);
                }
            }
            &:nth-of-type(2) {
                color: ${colors.text.tertiary};
                font-size: ${typography.size.desktop.paragraph.p3};
                line-height: calc(${typography.lineHeight[2]} - 1px);
                font-weight: ${typography.weight.normal};
            }
        }
    `};
`;

export const ListItemContainer = styled(StyledFlexContainer)`
    ${({ theme: { breakpoints } }) => `
        flex-direction: column;
        flex-grow: 1;
        flex-basis: 0;
        overflow: hidden;
        &.content-end {
            justify-content: end;
        }
        @media (max-width: ${breakpoints.md}) {
            flex-direction: row;
            overflow: auto;
            gap: 5px;
            & > div {
                height: 100%;
                flex: 1;
            }
        }      
    `};
`;

export const ListItem = styled(StyledFlexContainer)<{ isTradeExpand?: boolean }>`
    position: relative;
    justify-content: space-between;
    padding: 6px 16px 7px 17px;
    width: 100%;
    ${({ theme: { typography, colors, breakpoints }, isTradeExpand }) => `
        @media (min-height: ${breakpoints.xl}) {
            padding: 5.6px 16px 6.6px 17px;
        }
        &:hover {
            & > div {
                background: none !important;
            }
        }
        & > div {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            right: 0;
            z-index: 0;
            transform-origin: right;
        }
        & > span {
            display: inline-flex;
            align-items: center;
            color: ${colors.text.primary};
            font-size: ${typography.size.desktop.paragraph.p3};
            line-height: calc(${typography.lineHeight[2]} - 1px);
            letter-spacing: -0.02em;
            z-index: 1;
            &:nth-of-type(1) {
                width: ${!isTradeExpand ? '30%' : '33.33%'};
                & > span {
                    font-size: 18px;
                }
            }
            &:nth-of-type(2),
            &:nth-of-type(3) {
                width: ${!isTradeExpand ? '35%' : '33.33%'};
                justify-content: flex-end;
            }
            &:nth-of-type(2) {
                justify-content: ${!isTradeExpand ? 'flex-end' : 'center'};
            }
            & .cancel-order-tooltip {
                display: flex;
                align-items: center;
                & > svg {
                    width: 12px;
                    height: 12px;
                }
            }
            @media (max-width: ${breakpoints.md}) {
                width: 50% !important;
                &:nth-of-type(2) {
                    justify-content: flex-end;
                }
            }
        }
        @media (max-width: ${breakpoints.md}) {
            &.right {
                padding: 8px 4px 6px 16px;
                & > div {
                    right: 0;
                }
                & > span {
                    &:nth-of-type(1) {
                        order: 2;
                        justify-content: flex-end;
                    }
                    &:nth-of-type(2){
                        order: 1;
                        justify-content: flex-start;
                    }
                }
            }
            &.left {
                padding: 8px 11px 6px 5px;
                & > div {
                    left: 0;
                }
            }
        }
    `};
`;
